import {BaseEntity} from "./BaseEntity";

export class GpsLocationHistory implements BaseEntity {
    constructor(
        public id?:number,
        public timeSeen?:string,
        public assetID?:string,
        public latitude?:number,
        public longitude?:number){
    }
    parseJson(json: any): void {
    this.id = json.id;
        this.timeSeen = json.timeSeen;
        this.assetID = json.assetID;
        this.latitude = json.latitude;
        this.longitude = json.longitude;
    }
}
